import { createSelectorCreator, lruMemoize } from '@reduxjs/toolkit';
import deepEqual from 'fast-deep-equal';

export const createMemoizedSelector = createSelectorCreator(lruMemoize, deepEqual);
